import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-379a297b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { key: 0 }

import TopicItem from "@/components/TopicItem.vue";
import { useCourseStore } from "@/store/courseStore";
import axios from "axios";
import { onMounted, onUnmounted, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import DailyMilestoneBar from "@/components/DailyMilestoneBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseView',
  setup(__props) {

const topics = ref([]);
const isLoading = ref(true);
const userTier = ref("");
const router = useRouter();
const route = useRoute(); // Import 'useRoute' from 'vue-router'
const displayPopup = ref(false);
let timeoutId = null;

const courseStore = useCourseStore();
const courseId = courseStore.currentCourse?.id;
const courseName = courseStore.currentCourse?.name;
const courseDescription = courseStore.currentCourse?.description;
const userEnrollment = courseStore.currentCourse?.userEnrollment;
const courseType = courseStore.currentCourse?.type;

const getTopics = async () => {
  try {
    isLoading.value = true;
    const response = await axios.get(`api/course/${courseId}/topics`);
    topics.value = response.data;
    const profileResponse = await axios.get("api/users/profile");
    userTier.value = profileResponse.data.tier;
    isLoading.value = false;
    if (route.query.showPopup) {
      displayPopup.value = true;
      timeoutId = setTimeout(() => {
        displayPopup.value = false;
      }, 3500);
    }
  } catch (error) {
    isLoading.value = false;
    console.error("Failed to fetch topics", error.message);
  }
};

const enrollToCourse = async () => {
  try {
    await axios.post(`api/course/${courseId}/enroll`);
    if (courseType === "LANGUAGE_LEVEL") {
      router.push("/courses");
    } else {
      router.push("/exercises");
    }
  } catch (error) {
    console.error("Failed to enroll", error.message);
  }
};

onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});

onMounted(getTopics);

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "my-container" }, {
    default: _withCtx(() => [
      _createVNode(DailyMilestoneBar, { style: {"padding-bottom":"15px"} }),
      _createVNode(_component_v_sheet, { class: "dialog-sheet" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_dialog, {
            modelValue: displayPopup.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayPopup).value = $event)),
            "max-width": "700px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { variant: "elevated" }, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    style: {"padding":"5px"},
                    innerHTML: _ctx.$t('courseView.learnedWordExplanation')
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            variant: "elevated",
            width: "544px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "responsive-title" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(courseName)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { cols: "8" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_subtitle, { style: { whiteSpace: 'normal' } }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(userTier.value === "FREE"
                ? _ctx.$t("courseView.subscribe")
                : _unref(courseDescription)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
                default: _withCtx(() => [
                  (!_unref(userEnrollment))
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "outlined",
                        class: "mb-4",
                        onClick: enrollToCourse
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("courseView.startLearningButton")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t("courseView.loading")), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topics.value, (topic) => {
                return (_openBlock(), _createBlock(TopicItem, {
                  key: topic.id,
                  topic: topic,
                  userTier: userTier.value
                }, null, 8, ["topic", "userTier"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})